import {
  ACCESS_LEVELS,
} from '@/lib/consts.ts'
import { __t } from '@/lib/helpers'
import { ROUTE_META_PARAMS } from '@/router/consts.ts'

export default {
  path: 'staff',
  name: 'staff',
  meta: {
    [ROUTE_META_PARAMS.ACCESS_LEVEL]: ACCESS_LEVELS.RECEPTION,
    defaultSubroute: {
      name: 'staff.members',
    },
    hintKey: 'hintFeatureStaff',
  },
  component: () => import('@/views/business/staff/index.vue'),
  children: [
    {
      path: 'members',
      name: 'staff.members',
      meta: {
        title: __t('components.staff.tabs.members'),
        defaultSubroute: {
          name: 'staff.members.list',
        },
      },
      component: () => import('@/views/business/staff/members/index.vue'),
      children: [
        {
          path: 'new',
          name: 'staff.members.new',
          component: () => import('@/views/business/staff/members/form.vue'),
        },
        {
          path: ':stafferId/edit',
          name: 'staff.members.edit',
          component: () => import('@/views/business/staff/members/form.vue'),
        },
        {
          path: ':stafferId',
          name: 'staff.members.details',
          component: () => import('@/views/business/staff/members/list.vue'),
        },
        {
          path: '',
          name: 'staff.members.list',
          component: () => import('@/views/business/staff/members/list.vue'),
        },
      ],
    },
    {
      path: 'shifts',
      name: 'staff.shifts',
      meta: {
        title: __t('components.staff.tabs.shifts'),
        hintKey: 'hintFeatureShiftworks',
        hiddenForBaseAccessLevel: true,
      },
      component: () => import('@/views/business/staff/shifts/shifts.vue'),
    },
    {
      path: 'resources',
      name: 'staff.appliances',
      meta: {
        title: __t('components.staff.tabs.resources'),
        defaultSubroute: {
          name: 'staff.appliances.list',
        },
        hintKey: 'hintFeatureResources',
      },
      component: () => import('@/views/business/staff/appliances/index.vue'),
      children: [
        {
          path: 'new',
          name: 'staff.appliances.new',
          component: () => import('@/views/business/staff/appliances/form.vue'),
        },
        {
          path: ':applianceId/edit',
          name: 'staff.appliances.edit',
          component: () => import('@/views/business/staff/appliances/form.vue'),
        },
        {
          path: ':applianceId',
          name: 'staff.appliances.details',
          component: () => import('@/views/business/staff/appliances/list.vue'),
        },
        {
          path: '',
          name: 'staff.appliances.list',
          component: () => import('@/views/business/staff/appliances/list.vue'),
        },
      ],
    },
    {
      path: 'commissions',
      name: 'staff.commissions',
      component: () => import('@/views/business/staff/commissions/index.vue'),
      meta: {
        title: __t('components.staff.tabs.commissions'),
        hintKey: 'hintFeatureCommissions',
        hiddenForBaseAccessLevel: true,
      },
    },
  ],
}
